export default __webpack_public_path__ + "static/media/login_img.aa4a548e.png";